"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridMultiSelectionPlugin = void 0;
const react_1 = __importDefault(require("react"));
const sizing_1 = require("../../../design/constants/sizing");
const GridSelectionSubheader_1 = require("./components/GridSelectionSubheader/GridSelectionSubheader");
const gridCheckboxCell_1 = require("../../renderers/gridCheckboxCell");
const gridHeaderCheckboxCell_1 = require("../../renderers/gridHeaderCheckboxCell");
const selectionGridRow_1 = require("../../renderers/selectionGridRow");
const SELECTION_COLUMN_ID = '__internalSelectionColumn__';
function gridMultiSelectionPlugin(config) {
    const selectColumnSize = sizing_1.sizing.sizeSpaceXL.getIntValue() || 32;
    return () => {
        return {
            rowRenderer: (0, selectionGridRow_1.createGridSelectionRowRenderer)({
                onSelect: config.onSelect,
                isSelected: config.isSelected,
                isDisabled: config.isRowDisabled,
                onMultiSelect: config.onMultiSelect,
                onContextMenu: config.onContextMenu,
                onRowClick: config.onRowClick,
                onRowDoubleClick: config.onRowDoubleClick
            }),
            processColumns: (columns) => {
                if (!columns.filter((i) => !i.isService).length) {
                    return [];
                }
                if (!config.hasCheckbox) {
                    return columns;
                }
                return [
                    {
                        id: SELECTION_COLUMN_ID,
                        width: selectColumnSize,
                        order: -1,
                        minWidth: 32,
                        isService: true,
                        header: (0, gridHeaderCheckboxCell_1.gridHeaderCheckboxCell)({
                            onClick: config.onAllSelect,
                            isChecked: config.isAllSelected,
                            selectAllEnabled: config.selectAllEnabled
                        }),
                        cell: (0, gridCheckboxCell_1.gridCheckboxCell)({
                            onClick: (index, isShiftSelection) => config.onMultiSelect(index, isShiftSelection),
                            isChecked: config.isSelected,
                            isDisabled: config.isRowDisabled
                        })
                    },
                    ...columns
                ];
            },
            subheaderAddons: [
                {
                    id: 'selection-subheader',
                    order: -1,
                    render: () => {
                        if (typeof config.subheader === 'function') {
                            return config.subheader();
                        }
                        if (!config.subheader || !config.subheader.getTotal()) {
                            return react_1.default.createElement(react_1.default.Fragment, null);
                        }
                        return (react_1.default.createElement(GridSelectionSubheader_1.GridSelectionSubheader, { selected: config.subheader.getSelected(), total: config.subheader.getTotal(), texts: config.subheader.texts }));
                    }
                }
            ]
        };
    };
}
exports.gridMultiSelectionPlugin = gridMultiSelectionPlugin;
//# sourceMappingURL=gridMultiSelectionPlugin.js.map